import { doc, getFirestore, setDoc } from 'firebase/firestore';

const getValue = (fld, data) => {
	if (typeof fld?.valueFunction === 'function') return fld?.valueFunction(data);
	if (typeof fld?.value === 'function') return fld?.value(data);
	return fld?.function(data) || '';
};

export const tableSort = (a, b, sortFields, tableFields) => {
	for (const sortField of sortFields) {
		const dir = sortField.dir;
		const heading = sortField.heading;
		const fld = tableFields.find((f) => f.heading === heading);

		const valueA = getValue(fld, a);
		const valueB = getValue(fld, b);
		// console.log({ valueA, valueB, fld });
		if (typeof valueA !== 'undefined' && typeof valueB !== 'undefined' && valueA !== valueB) {
			// console.log((dir === 'desc' && valueA > valueB) || valueA < valueB ? -1 : 1);
			if (dir === 'desc') {
				return valueA > valueB ? -1 : 1;
			} else {
				return valueA < valueB ? -1 : 1;
			}
		}
	}
	return a?.index < b?.index ? -1 : 1;
};

export const sortField = async (e, uid, col, tableFields, tableSortFields) => {
	if (typeof uid !== 'string') return;

	const heading = e.target.closest('th').getAttribute('heading');

	const fld = tableFields.find((f) => f.heading === heading);
	if (!fld.function) return;
	const newSortFields = [...tableSortFields];

	if (tableSortFields.map((f) => f.heading).includes(heading)) {
		const index = tableSortFields.map((f) => f.heading).indexOf(heading);
		if (tableSortFields[index].dir === 'asc') {
			newSortFields[index].dir = 'desc';
		} else {
			newSortFields.splice(index, 1);
		}
	} else {
		newSortFields.push({
			heading,
			dir: 'asc'
		});
	}

	const updates = {
		[col]: {
			tableSortFields: newSortFields
		}
	};

	const profileDocRef = doc(getFirestore(), 'profiles', uid);
	await setDoc(profileDocRef, { collectionCriteria: updates }, { merge: true });

};
